module.exports = __webpack_public_path__ + "img/2.63ce89cb.png";